const zIndexesStack = ['basic', 'popover', 'notification'] as const;
type ZIndexItems = typeof zIndexesStack[number];

export const zIndex = (item: ZIndexItems): number => zIndexesStack.indexOf(item);
